export const GET_INSTANCES = 'providers/Instances/GET_INSTANCES';
export const CREATE_INSTANCE = 'providers/Instances/CREATE_INSTANCE';
export const DELETE_INSTANCE = 'providers/Instances/DELETE_INSTANCE';
